import axios from 'axios';
import { getImpersonationHeader } from '../util';
import { authorize } from '../../AWS';
import { apiGatewayBaseUrl } from '../services';

// Download Instance
const downloadInstance = axios.create({
  baseURL: apiGatewayBaseUrl,
  responseType: 'blob',
});

downloadInstance.interceptors.request.use(
  async (config) => {
    const authorization = await authorize();
    if (!authorization) {
      return Promise.reject(new Error('Login again'));
    }

    // Preserve any existing headers, then inject auth & impersonation
    config.headers = {
      ...config.headers,
      Authorization: authorization,
      ...getImpersonationHeader(),
    };

    return config;
  },
  (error) => Promise.reject(error),
);

downloadInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export { downloadInstance };
